import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import { doesExist } from "@shared/backend/entity-security/does-exist";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { Association } from "../association";
import { Group } from "../group/entity";
import { type GroupAssociation } from "./entity";

export const GroupAssociationEntityConfig: HyperEntityConfig<GroupAssociation> =
{
  allowApiRead: Allow.authenticated,
  allowApiCrud: [Roles.Admin, Roles.SuperAdmin, Roles.Manager, Roles.User],
  apiPrefilterPerRole: async (filter) => {
    filter(Roles.All, {
      group: {
        $is: await copyApiPrefilterPerRole(Group),
      },
    });

    filter(Roles.All, {
      association: {
        $is: await copyApiPrefilterPerRole(Association),
      },
    });
  },

  allowInsertPerRole(allow) {
    allow(Roles.User, (entity) => {
      console.log(entity);
      console.log(remult.user!.associations);
      return remult.user!.associations!.includes(entity.associationId);
    }
    );

    allow(Roles.OrganizationManagers, (entity) =>
      doesExist(Group, {
        id: entity.groupId,
        organization: {
          $id: remult.user!.organizationId!,
        },
      }),
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.User, (entity) =>
      remult.user!.associations!.includes(entity.associationId),
    );

    allow(Roles.OrganizationManagers, {
      group: {
        $is: {
          organization: {
            $id: remult.user!.organizationId!,
          },
        },
      },
    });
  },

  id: {
    groupId: true,
    associationId: true,
  },
};
